import gettext from '@sdk/lang/gettext';

import { PsatSteps } from '@web/components/psatScore/types';
import {
  SurveyCommentStepType,
  SurveyFinishStepType,
  SurveyStepType,
} from '@web/components/survey/types';

export const PSAT_STEPS_CONFIG = {
  [PsatSteps.rate]: {
    number: 1,
  } as SurveyStepType,
  [PsatSteps.comment1]: {
    text: gettext('Thank you for your feedback! Why did you give that rating?'),
  } as SurveyCommentStepType,
  [PsatSteps.finish]: {
    title: gettext('Thank you for your input!'),
    subtitle: gettext(
      'We highly value all feedback from customers and use it to keep improving our product for you.'
    ),
  } as SurveyFinishStepType,
  [PsatSteps.finishCall]: {
    title: gettext('Thank you for your input!'),
    subtitle: gettext(
      'We highly value all feedback from customers and use it to keep improving our product. We would love to hear more from you over a call.'
    ),
  } as SurveyFinishStepType,
};
